angular.module('cimerFrontEndApp').directive('surveySectionDisplay', ['SurveyService', '$uibModal', 'TextEditorService',  function (SurveyService, $uibModal, TextEditorService) {
    'use strict';
    return {
        restrict: 'EA',
        templateUrl: '/Content/Templates/surveySectionDisplayTemplate.html',
        scope: {
            /* A section object has the following structure, which matches what is in customSurvey.js:
             * sectionName: corresponds to SectionText
             * SectionID: corresponds to SectionID
             * SectionRoleID: corresponds to SectionRoleID
             * questions: an array of question objects, each of which has the following structure (built in survey.srv.js parseQuestionPrompts):
             *      description: corresponds to QuestionLabel
             *      type: corresponds to QuestionType
             *      typeID: corresponds to QuestionTypeID
             *      details: has all the raw data from the question
             * Validated: if we're creating/editing a base survey
             * collapse: whether the section should be open or collapsed
             */
            section: '=section',
            index: '=index',
            form: '=form',
            formSubmitted: '=formSubmitted',
            directorId: '=directorId',
            deleteSection: '&',
            tinymceOptions: '=tinymceOptions'
        },
        link: function (scope) {
            scope.sectionRoleEnum = SurveyService.QuestionRole;
            // If we're editing a base survey, we won't have a director id, so determine base/custom survey context from that variable
            scope.contextIsCustomSurvey = scope.directorId !== null;
            // Set the initial properties
            updateProperties(scope.section);
            scope.editSectionName = false;
            scope.sectionNameLength = 0;
            scope.sectionNameMaxLength = 5000;
            // Update the scope properties if the section is updated (for example, via rearrangement)
            scope.$watch(function () { return scope.section; }, function (s) {
                updateProperties(s);
            });

            // Set up variables to use on the front-end to keep the HTML clean
            function updateProperties(section) {
                
                scope.isBase = section.SectionRoleID === scope.sectionRoleEnum.Base;
                scope.isCurated = section.SectionRoleID === scope.sectionRoleEnum.Curated;
                scope.isCustom = section.SectionRoleID === scope.sectionRoleEnum.Custom;

                scope.isEditable = scope.isCustom || !scope.contextIsCustomSurvey;

                scope.sectionNameLength = TextEditorService.GetPlainTextLength(scope.section.sectionName);

                scope.sortableOptions = {
                    // Disable sorting if we're in a custom survey and the section is not a custom section
                    disabled: scope.contextIsCustomSurvey && !scope.isCustom,
                    handle: '.question-drag-and-drop',
                    update: function (event, ui) {
                        var startPos = ui.item.sortable.index; // the original position of the question being moved
                        var newPos = ui.item.sortable.dropindex; // the location where the user wants to move it to
                        if (questionIsParent(ui.item.sortable.model)) {
                            // If a parent question got moved up in the section, it will still be before all its children, so nothing to worry about
                            if (newPos < startPos) {
                                return;
                            }
                            var parent = ui.item.sortable.model;
                            // Otherwise, look at all of the questions in between its original position and its new position to make sure none of them are the children of this question
                            for (var i = startPos + 1; i < newPos + 1; i++) {
                                if (questionIsChildOfParent(scope.section.questions[i], parent)) {
                                    // Can't move the parent to be after a child, cancel the sorting
                                    ui.item.sortable.cancel();
                                    $uibModal.open({
                                        animation: true,
                                        templateUrl: '/Content/Templates/survey/sortingValidationModal.html',
                                        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                                            $scope.message = "Cannot move this question after question " + (i+1) + " because the logic on question " + (i+1) + " depends on this question";
                                            $scope.cancel = function () { $uibModalInstance.dismiss('cancel'); };
                                        }],
                                        size: 'sm'
                                    }).result.then(function () { }, function () { }); // do nothing on modal close, prevent console errors
                                    break; // break loop to not display more modals if they tried to move it past multiple children
                                }
                            }
                        }
                        else if (questionIsChild(ui.item.sortable.model)) {
                            // If a child question got moved down in the section, it will still be after all its parents, so nothing to worry about
                            if (newPos > startPos) {
                                return;
                            }
                            var child = ui.item.sortable.model;
                            // Otherwise, look at all of the questions in between its original position and its new position to make sure none of them are the parent of this question
                            for (var j = startPos - 1; j > newPos - 1; j--) {
                                if (questionIsChildOfParent(child, scope.section.questions[j])) {
                                    ui.item.sortable.cancel();
                                    $uibModal.open({
                                        animation: true,
                                        templateUrl: '/Content/Templates/survey/sortingValidationModal.html',
                                        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                                            $scope.message = "Cannot move this question before question " + (j+1) + " because question " + (j+1) + " determines the display of this question";
                                            $scope.cancel = function () { $uibModalInstance.dismiss('cancel'); };
                                        }],
                                        size: 'sm'
                                    }).result.then(function () { }, function () { });
                                    break; // break loop to not display more modals if they tried to move it past multiple parents
                                }
                            }
                        }
                    }
                };
            }

            var _createQuestionModal = function (customObject) {
                // Verify matrix questions are consistent
                if (customObject.hasOwnProperty('Questions')) {
                    for (var i = 0; i < customObject.Questions.length; i++) {
                        customObject.Questions[i].QuestionPromptText = customObject.QuestionPromptText;
                        customObject.Questions[i].QuestionLabel = customObject.QuestionLabel;
                        customObject.Questions[i].QuestionScale = customObject.QuestionScale;
                        customObject.Questions[i].QuestionScaleID = customObject.QuestionScaleID;
                    }
                }
                var tempObject = {
                    description: customObject.QuestionLabel,
                    typeID: customObject.QuestionTypeID,
                    type: customObject.QuestionType,
                    details: customObject,
                    detailText: ''
                };
                if (tempObject.typeID === 0) { //matrix
                    tempObject.getID = function (index) { return this.details.Questions[index].QuestionID || this.details.Questions[index].tempID; };
                }
                else {
                    tempObject.getID = function () { return this.details.QuestionID || this.details.tempID; };
                }

                if (!scope.section.hasOwnProperty('questions') || scope.section.questions === undefined) {
                    scope.section.questions = [];
                }
                scope.section.questions.push(tempObject);
            };

            scope.editSectionNameCallback = function (newVal) {
                if (!scope.isEditable) { return; }
                scope.editSectionName = newVal;
            };

            scope.checkSectionNameLength = function () {
                scope.sectionNameLength = TextEditorService.GetPlainTextLength(scope.section.sectionName);
                scope.updateValidity(scope.sectionNameLength, scope.sectionNameMaxLength, scope.form['sectionName'], "sectionName");
            };

            scope.updateValidity = function (fieldLength, fieldMax, form, fieldName) {
                if (fieldLength > fieldMax) {
                    form.$setValidity(fieldName, false);
                }
                else {
                    form.$setValidity(fieldName, true);
                }
            };

            // Add a new question to the section
            scope.displayCreateQuestionModal = function () {

                var createQuestionModalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: '/Content/Templates/survey/createQuestionModal.html',
                    controller: 'CreateQuestionModalCtrl',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {
                        directorID: function () {
                            return scope.directorId;
                        }
                    }
                });

                createQuestionModalInstance.result.then(function (customObject) {
                    // Shouldn't be able to add questions to a base or curated section in a custom survey context
                    if (scope.contextIsCustomSurvey && !scope.isCustom) { return; }

                    if (customObject.QuestionLabel === '') {
                        var prompt = customObject.Text;
                        if (customObject.hasOwnProperty('QuestionPromptText')) {
                            prompt = customObject.QuestionPromptText;
                        }
                        TextEditorService.ConvertToPlainText(prompt)
                            .then(function (result) {
                                customObject.QuestionLabel = result;
                                _createQuestionModal(customObject);
                            });
                        return;
                    }
                    _createQuestionModal(customObject);
                }, function () {
                    //modal cancelled - do nothing
                });

            }; // end displayCreateQuestionModal


            // Delete a question from a section
            scope.removeQuestionFromSection = function (questionIndex) {
                // Shouldn't be editing base or curated sections in a custom survey
                if (scope.contextIsCustomSurvey && !scope.isCustom) { return; }
                scope.section.questions.splice(questionIndex, 1);
            }; // end removeQuestionFromSection

            // Edit the display logic for a question
            scope.editQuestionDisplayLogic = function (questionIndex) {
                // Get all of the options for parent questions - all of the single or multi select questions that occur
                // before the passed in question in the section and are not child questions themselves
                var parentOptions = [];
                for (var i = 0; i < questionIndex; i++) {
                    // Select only the single select (1) and multi select questions (4) that are not already child questions
                    if ((scope.section.questions[i].typeID === 1 || scope.section.questions[i].typeID === 4) && !questionIsChild(scope.section.questions[i]))
                    {
                        /* Format of a parent question object:
                         * ParentQuestionID: id,
                         * QuestionTextPlainText: string,
                         * ScaleAnswers: [{ScaleAnswerModel}] - note these are the scale answers selected for the branch
                         * ParentQuestionType: int,
                         * shortPrompt: string - used for display in the dropdown
                         * scaleAnswerOptions: [{ScaleAnswerModel}] - all the scale answer options for the parent question
                         */

                        // Format each parent candidate to match the above object so it'll match up with existing branches
                        // Don't need any special matrix question processing since matrix questions can't be parents
                        var parentQuestion = {
                            ParentQuestionID: scope.section.questions[i].getID(),
                            QuestionTextPlainText: scope.section.questions[i].details.TextPlain,
                            ScaleAnswers: [], // since these are the selected branches in the model, don't fill in here for the candidates
                            ParentQuestionType: scope.section.questions[i].typeID,
                            scaleAnswerOptions: angular.copy(scope.section.questions[i].details.QuestionScale)
                        };
                        // Also add a shortened prompt value for display in the dropdowns
                        parentQuestion.shortPrompt = parentQuestion.QuestionTextPlainText.length > 40 ? 'Q' + (i+1) + ' ' + parentQuestion.QuestionTextPlainText.substring(0, 30) + '...' + parentQuestion.QuestionTextPlainText.substring(parentQuestion.QuestionTextPlainText.length - 10, parentQuestion.QuestionTextPlainText.length) : 'Q' + (i+1) + ' ' + parentQuestion.QuestionTextPlainText;
                        for (var j = 0; j < parentQuestion.scaleAnswerOptions.length; j++) {
                            parentQuestion.scaleAnswerOptions[j].shortPrompt = parentQuestion.scaleAnswerOptions[j].AnswerTextPlainText.length > 15 ? parentQuestion.scaleAnswerOptions[j].AnswerTextPlainText.substring(0, 10) + '...' + parentQuestion.scaleAnswerOptions[j].AnswerTextPlainText.substring(parentQuestion.scaleAnswerOptions[j].AnswerTextPlainText.length - 5, parentQuestion.scaleAnswerOptions[j].AnswerTextPlainText.length) : parentQuestion.scaleAnswerOptions[j].AnswerTextPlainText;
                            // The multi select dropdown can't accept a function or an '||' for the id property, so put it here
                            parentQuestion.scaleAnswerOptions[j]._id = parentQuestion.scaleAnswerOptions[j].getID();
                        }
                        parentOptions.push(parentQuestion);
                    }
                }
                // If there are existing logic branches, add a shortened prompt to each of them for display in the dropdowns
                var childQuestion = angular.copy(scope.section.questions[questionIndex]);
                // Find the question branches, different processing for matrix questions (typeID 0)
                var childQuestionBranches = childQuestion.typeID !== 0 ? childQuestion.details.QuestionBranches : childQuestion.details.Questions[0].QuestionBranches;
                for (i = 0; i < childQuestionBranches.length; i++) {
                    for (j = 0; j < childQuestionBranches[i].ParentQuestions.length; j++) {
                        // Find the matching question from the parent options
                        var parentOption = parentOptions.find(q => q.ParentQuestionID === childQuestionBranches[i].ParentQuestions[j].ParentQuestionID);
                        // Set display properties to match
                        childQuestionBranches[i].ParentQuestions[j].shortPrompt = parentOption.shortPrompt;
                        childQuestionBranches[i].ParentQuestions[j].scaleAnswerOptions = parentOption.scaleAnswerOptions;
                        for (var k = 0; k < childQuestionBranches[i].ParentQuestions[j].ScaleAnswers.length; k++) {
                            childQuestionBranches[i].ParentQuestions[j].ScaleAnswers[k]._id = childQuestionBranches[i].ParentQuestions[j].ScaleAnswers[k].getID();
                        }
                    }
                }

                var displayLogicModalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: '/Content/Templates/survey/displayLogicModal.html',
                    controller: 'DisplayLogicModalCtrl',
                    size: 'lg',
                    resolve: {
                        question: function () {
                            return childQuestion;
                        },
                        parentOptions: function () {
                            return parentOptions;
                        }
                    }
                });

                displayLogicModalInstance.result.then(function (parentQuestions) {
                    updateQuestionLogic(scope.section.questions[questionIndex], parentQuestions);
                }, function () {
                    //modal cancelled - do nothing
                    
                });
            };

            scope.deleteQuestionDisplayLogic = function (questionIndex) {
                // Call updateQuestionLogic with an empty parent array to remove all the branches from the question and update parents accordingly
                updateQuestionLogic(scope.section.questions[questionIndex], []);
            };

            scope.updateChildrenOfParent = function (parentQuestionIndex, parentObj) {
                // The parent question with the updated information needs to be passed in because angular.copy can be slow enough 
                // where the parent question is not yet updated in scope.section.questions before this function is called
                // Loop through all the questions after this parent, looking for its children
                for (var i = parentQuestionIndex + 1; i < scope.section.questions.length; i++) {
                    var matrixBranchesUpdated = false;
                    var branches = scope.section.questions[i].typeID === 0 ? scope.section.questions[i].details.Questions[0].QuestionBranches : scope.section.questions[i].details.QuestionBranches;
                    if (branches.length > 0) {
                        for (var j = 0; j < branches.length; j++) {
                            for (var k = 0; k < branches[j].ParentQuestions.length; k++) {
                                if (branches[j].ParentQuestions[k].ParentQuestionID === parentObj.getID()) {
                                    // This parent object needs to be updated
                                    var parentBranchObj = branches[j].ParentQuestions[k];
                                    parentBranchObj.QuestionTextPlainText = parentObj.details.TextPlain;
                                    for (var l = 0; l < parentBranchObj.ScaleAnswers.length; l++) {
                                        var scaleAnswerObj = parentObj.details.QuestionScale.find(sa => sa.getID() === parentBranchObj.ScaleAnswers[l].getID());
                                        parentBranchObj.ScaleAnswers[l].AnswerText = scaleAnswerObj.AnswerText;
                                        parentBranchObj.ScaleAnswers[l].AnswerTextPlainText = scaleAnswerObj.AnswerTextPlainText;
                                        parentBranchObj.ScaleAnswers[l].NotApplicable = scaleAnswerObj.NotApplicable;
                                        parentBranchObj.ScaleAnswers[l].CompositeScoreRecodeValue = scaleAnswerObj.CompositeScoreRecodeValue;
                                    }
                                    // If the child question was a matrix, we'll need to update the other questions in the matrix as well
                                    matrixBranchesUpdated = scope.section.questions[i].typeID === 0;
                                }
                            }
                        }
                    }
                    if (matrixBranchesUpdated) {
                        // The matrix question at index 0 will have the updated information, so copy all the information in to the rest of the matrix questions
                        var matrixQuestions = scope.section.questions[i].details.Questions;
                        for (var m = 1; m < matrixQuestions.length; m++) {
                            matrixQuestions[m].QuestionBranches = matrixQuestions[0].QuestionBranches;
                        }
                    }
                }
            };

            var updateQuestionLogic = function (childQuestion, parentQuestions) {
                var hadExistingLogic = false;
                var originalParentScaleAnswerPairs = [];
                var originalBranches = childQuestion.typeID === 0 ? childQuestion.details.Questions[0].QuestionBranches : childQuestion.details.QuestionBranches;
                // If the child had question branches on it before the edit, fetch them so we'll be able to tell if any were deleted
                if (originalBranches.length > 0) {
                    hadExistingLogic = true;
                    for (var i = 0; i < originalBranches.length; i++) {
                        for (var j = 0; j < originalBranches[i].ParentQuestions.length; j++) {
                            for (var k = 0; k < originalBranches[i].ParentQuestions[j].ScaleAnswers.length; k++) {
                                originalParentScaleAnswerPairs.push(
                                    {
                                        PQID: originalBranches[i].ParentQuestions[j].ParentQuestionID,
                                        QBID: originalBranches[i].ParentQuestions[j].ScaleAnswers[k].QuestionBranch.getID()
                                    });
                            }
                        }
                    }
                }

                // Now process all of the parent questions submitted from the modal
                // Tell each parent question it's parent and which scale answer is being used
                for (var l = 0; l < parentQuestions.length; l++) {
                    // Find the original parent question
                    for (var m = 0; m < scope.section.questions.length; m++) {
                        // Make sure we don't try to get the wrong getID() function by short circuiting away from matrix questions (which can't be parents anyways)
                        if (scope.section.questions[m].typeID !== 0 && scope.section.questions[m].getID() === parentQuestions[l].ParentQuestionID) {
                            var newParent = scope.section.questions[m].details;
                            for (var n = 0; n < parentQuestions[l].ScaleAnswers.length; n++) {
                                // Find the corresponding scale answer in the original parent object and mark it as a new parent with the branch ID
                                var scale = newParent.QuestionScale.find(sa => sa.getID() === parentQuestions[l].ScaleAnswers[n].getID());
                                scale.QuestionBranch = angular.copy(parentQuestions[l].ScaleAnswers[n].QuestionBranch); // do copy over the whole object and do a full copy to trigger the question's watchers
                                // If we had existing branches and this question branch ID is in our array of existing branches, remove it from the array to signify it's still in use
                                if (hadExistingLogic) {
                                    var existingIndex = originalParentScaleAnswerPairs.findIndex(obj => obj.QBID === scale.QuestionBranch.getID());
                                    if (existingIndex !== -1) {
                                        originalParentScaleAnswerPairs.splice(existingIndex, 1);
                                    }
                                }
                            } // end scale answers loop
                            break; // If we've updated our parent objects, break out of the loop that is trying to find the parent object
                        }
                    }
                }
                // Now update the child question
                // If it's a matrix question, update all of the questions within the matrix
                if (childQuestion.typeID === 0) {
                    var matrixQuestions = childQuestion.details.Questions;
                    for (var o = 0; o < matrixQuestions.length; o++) {
                        // If it's returning no parents, remove the question branch property from each question
                        if (parentQuestions.length === 0) {
                            matrixQuestions[o].QuestionBranches = [];
                        }
                        else {
                            matrixQuestions[o].QuestionBranches = [
                                {
                                    QuestionToDisplayID: childQuestion.getID(o),
                                    ParentQuestions: parentQuestions
                                }];
                        }
                    }
                }
                else {
                    // If it's returning no parents, remove the question branch property
                    if (parentQuestions.length === 0) {
                        childQuestion.details.QuestionBranches = [];
                    }
                    else {
                        childQuestion.details.QuestionBranches = [{
                            QuestionToDisplayID: childQuestion.getID(),
                            ParentQuestions: parentQuestions
                        }];
                    }
                }
                // If there are any objects remaining in the original list, it means those branches were removed
                for (var p = 0; p < originalParentScaleAnswerPairs.length; p++) {
                    // Check each parent in this list. If it has no more children, it is no longer a parent and its own logic/deletion restrictions can be removed.
                    updateParentAfterLogicDeletion(originalParentScaleAnswerPairs[p].PQID, originalParentScaleAnswerPairs[p].QBID);
                }
            };

            var updateParentAfterLogicDeletion = function (parentQuestionID, questionBranchID) {
                // Check every question in the section after this parent question to see if any are still using the questionBranchID
                var questions = scope.section.questions;
                var parentIndex = questions.findIndex(q => q.getID() === parentQuestionID);
                for (var i = parentIndex + 1; i < questions.length; i++) {
                    // If this question is a child of the parent branch, it's still a parent and we can just exit
                    if (questionHasBranch(questions[i], parentQuestionID, questionBranchID)) {
                        // Some question is still using this branch, no updating needed
                        return;
                    }
                }
                // If we got all the way here, it means no one is using this branch anymore and it can be deleted off the parent
                var parentObj = questions[parentIndex];
                var scaleAnswer = parentObj.details.QuestionScale.find(sa => sa.QuestionBranch.getID() === questionBranchID);
                scaleAnswer.QuestionBranch = { // delete the branch by setting it back to an empty object
                    QuestionBranchID: null,
                    TempBranchID: null,
                    getID: function () { return this.QuestionBranchID || this.TempBranchID; }
                }; 
            };

            var questionHasBranch = function (question, parentQuestionID, questionBranchID) {
                var branches;
                if (question.typeID === 0) { //matrix
                    branches = question.details.Questions[0].QuestionBranches; // matrix questions all have the same branches, so just grab the first one
                }
                else {
                    branches = question.details.QuestionBranches;
                }
                for (var i = 0; i < branches.length; i++) {
                    var pq = branches[i].ParentQuestions.find(q => q.ParentQuestionID === parentQuestionID);
                    if (pq !== undefined) {
                        var sa = pq.ScaleAnswers.find(sa => sa.QuestionBranch.getID() === questionBranchID);
                        if (sa !== undefined) { return true; } // we found a match
                    }
                }
                // If we got all the way here, it's not using it
                return false;
            };

            var questionIsChild = function (questionObj) {
                if (questionObj.details.hasOwnProperty("QuestionPromptText")) {
                    return questionObj.details.Questions[0].QuestionBranches.length > 0; // Every matrix question will have the same question branches, so we only need to check the first one
                }
                else {
                    return questionObj.details.QuestionBranches.length > 0;
                }
            };

            var questionIsParent = function (questionObj) {
                // Matrix and text questions can't be parents
                if (questionObj.typeID === 0 || questionObj.typeID === 3) { return false; }
                // A question is a parent object if any of its scale answers have a question branch ID
                return questionObj.details.QuestionScale.filter(sa => sa.QuestionBranch.getID() !== null).length > 0;
            };

            var questionIsChildOfParent = function (childObj, parentObj) {
                // Get the branches off the child
                var branches = childObj.typeID === 0 ? childObj.details.Questions[0].QuestionBranches : childObj.details.QuestionBranches;
                for (var i = 0; i < branches.length; i++) {
                    return branches[i].ParentQuestions.findIndex(pq => pq.ParentQuestionID === parentObj.getID()) !== -1;
                }
                return false;
            };
        }
    };
}]);

// Directive to automatically focus an element when ngShow is triggered on the element
// Add the focus-on-show attribute to the element to apply it ex. <input type="text" ng-show="editing" focus-on-show>
angular.module('cimerFrontEndApp').directive('focusOnShow', ['$timeout', function ($timeout) {
    'use strict';
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (attr.ngShow) {
                scope.$watch(attr.ngShow, function (newVal) {
                    if (newVal) {
                        $timeout(function () {
                            element[0].focus();
                        }, 20); // small timeout so it doesn't try to focus before the element is rendered
                    }
                });
            }
        }
    };
}]);